import { useEffect, useRef, useState } from "react";
import { Drawer } from "../../../components/drawers/Drawer";
import { closeChatQuickReplies, useHub, useQuickReplies } from "../../../core/Global";
import Div from "../../../components/base/Div";
import Indicator from "../../../components/base/Indicator";
import FlexRow from "../../../components/base/FlexRow";
import TextBox from "../../../components/form/TextBox";
import { ChatQuickReplyItem } from "../models/ChatQuickReplyItem ";
import { API_ROUTES } from "../../../core/Constants";
import Form from "../../../components/form/Form";
import Icon from "../../../components/base/Icon";
import { toastSuccess } from "../../../components/base/Toast";
import ToggleSwitch from "../../../components/form/ToggleSwitch";


export default function ChatQuickRepliesManage() {

    const hub = useHub()
    const replies = useQuickReplies()

    const titleInput = useRef<HTMLInputElement>(null)
    const textInput = useRef<HTMLInputElement>(null)
    const longtextInput = useRef<HTMLTextAreaElement>(null)


    const [longMessage, longMessageSet] = useState<boolean>(false)
    const [working, workingSet] = useState<boolean>(false)

    const [title, titleSet] = useState<string>("")
    const [text, textSet] = useState<string>("")


    return (
        <>
            <Drawer id="drawer-form-quickreplies"
                title="Quick Replies"
                onOpen={() => textInput.current?.focus()}
                onClose={closeChatQuickReplies}>

                <Form className="mb-5"
                    onSubmit={body => {
                        workingSet(true)

                        hub.Post(API_ROUTES.ChatQuickReplies, {
                            text: text,
                            title: title
                        }, res => {
                            if (res.success) {
                                workingSet(false)
                                textSet("")
                                titleSet("")
                            }
                        })

                    }}>
                    <div className="row align-items-center mb-5">
                        <div className="col-7">
                            <ToggleSwitch small raw label="Create Long Message!"
                                checked={longMessage}
                                onChange={e => longMessageSet(e)} />
                        </div>
                    </div>
                    {
                        longMessage ?
                            <>
                                <div className="row align-items-center mb-5">
                                    <div className="col-12">
                                        <input key="txt-reply-title" className="form-control form-inputs" ref={titleInput}
                                            placeholder="Write a title..." value={title}
                                            onChange={e => titleSet(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center mb-5">
                                    <div className="col-12">
                                        <textarea key="txt-reply-longtext" className="form-control form-inputs" ref={longtextInput}
                                            placeholder="Quick reply..." value={text} rows={5}
                                            onChange={e => textSet(e.target.value)}></textarea>
                                    </div>
                                </div>

                                <div className="row align-items-center mb-5">
                                    <div className="col-12 text-end">
                                        <button type="submit" className="btn btn-primary btn-sm" disabled={working}>
                                            {
                                                working ?
                                                    <>
                                                        <Indicator text="Adding..." />
                                                    </>
                                                    :
                                                    <>
                                                        <Icon icon="plus" />
                                                        Add
                                                    </>
                                            }
                                        </button>
                                    </div>
                                </div>
                            </>
                            :
                            <div className="row align-items-center">
                                <div className="col-7">
                                    <input key="txt-reply-text" className="form-control form-inputs" ref={textInput}
                                        placeholder="Quick reply..." value={text}
                                        onChange={e => textSet(e.target.value)}
                                    />
                                </div>
                                <div className="col-5">
                                    <button type="submit" className="btn btn-primary btn-sm" disabled={working}>
                                        {
                                            working ?
                                                <>
                                                    <Indicator text="Adding..." />
                                                </>
                                                :
                                                <>
                                                    <Icon icon="plus" />
                                                    Add
                                                </>
                                        }
                                    </button>
                                </div>
                            </div>
                    }


                </Form>

                <hr />

                <div>
                    {
                        replies.map(r =>
                            <FlexRow key={`reply-${r.id}`} className="border-bottom list-card">
                                <div style={{
                                    maxWidth: "70%"
                                }}>
                                    <div>
                                        {r.title}
                                    </div>
                                    {
                                        r.title != r.text &&
                                        <div className="fs-8 text-gray-700 line-break">
                                            {r.text}
                                        </div>
                                    }
                                </div>
                                <div className="ms-auto">
                                    <button type="button" disabled={working}
                                        className="btn btn-sm btn-light-danger btn-active-light-danger btn-icon"
                                        onClick={e => {
                                            e.preventDefault()

                                            hub.Delete(API_ROUTES.ChatQuickReplies + r.id, res => {
                                                if (res.success) {
                                                    workingSet(false)
                                                }
                                            })


                                        }}>
                                        <Icon icon="trash" />
                                    </button>
                                </div>
                            </FlexRow>
                        )
                    }

                </div>

            </Drawer>

        </>
    )
}